export default __webpack_public_path__ + "static/media/map_user.041d53ff.svg";